<template>
  <div class="auto-fit-container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AutoFitContainer'
}
</script>

<style scoped>
.auto-fit-container {
  position: absolute;
  inset: 0; /* 填满父容器 */
  overflow: hidden; /* 防止内容溢出出现滚动条 */
  display: flex;
  flex-direction: column;
}
</style>